import { BoumRight } from '@moia-dev/moia-token-claims'

// AREA_FETCH stays accepted until every Fleet Tracing user holds FLEET_TRACING_R.
export const VEHICLE_TRACING_RIGHTS = [
  BoumRight.FLEET_TRACING_R,
  BoumRight.AREA_FETCH,
]
